import {Pipe, PipeTransform} from '@angular/core';
import {ServerModel} from '../models/server.model';

@Pipe({
  name: 'lbaServerFilterPipe',
})
export class ServerFilterPipe implements PipeTransform {

  transform(servers: Array<ServerModel>, searchStr: string): any {
    searchStr = searchStr.toString().toLowerCase();
    const filteredServers: Array<ServerModel> = [];
    if (searchStr.length === 0) {
      return servers;
    }
    for (const module of servers){
      if (
        module.name.toLowerCase().indexOf(searchStr) !== -1 ||
        module.id.toString().indexOf(searchStr) !== -1 ||
        module.domain.toLowerCase().indexOf(searchStr) !== -1
      ) {
        filteredServers.push(module);
      }
    }
    return filteredServers;
  }

}
